/**
 * [DOCK-MOTION 2026-09-22] Which side the next page enters from, handed from the dock
 * (BottomNav) to AppLayout's PageFade.
 *
 * A dock click records the direction of travel; PageFade reads it while it renders the new page
 * and puts it on its OWN inline style as --page-enter-x / --page-enter-y, so the page drifts in
 * 16px from the side of the tab that was clicked.
 *
 * Why not a CSS variable on <html>: a custom property set on the root makes the browser re-check
 * the style of every element on the page. Leaving Inventory (thousands of table cells) that held
 * the click for ~170 ms, and the dock's glide could not start until it finished. Here only the
 * new, still-empty page is touched.
 */
import type { CSSProperties } from 'react';

/** How long a dock click counts as the reason for the next page change. The route change
 *  follows the click one frame later, so this is generous. */
const FRESH_MS = 1000;

let last: { dir: 1 | -1; at: number } | null = null;

export function setPageEnterSide(dir: 1 | -1): void {
  last = { dir, at: Date.now() };
}

/** Style for the page wrapper: after a dock click, enter from that side; for any other navigation
 *  (a link, the Back button) undefined, which keeps the default 6px rise. Pure read, so a double
 *  render gives the same answer. */
export function pageEnterStyle(): CSSProperties | undefined {
  if (!last || Date.now() - last.at > FRESH_MS) return undefined;
  return { '--page-enter-x': `${last.dir * 16}px`, '--page-enter-y': '0px' } as CSSProperties;
}
